import { render, staticRenderFns } from "./my-slide-box.vue?vue&type=template&id=2211f1f4&scoped=true&"
import script from "./my-slide-box.vue?vue&type=script&lang=js&"
export * from "./my-slide-box.vue?vue&type=script&lang=js&"
import style0 from "./my-slide-box.vue?vue&type=style&index=0&id=2211f1f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211f1f4",
  null
  
)

export default component.exports